<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Image URL</label>
      <input 
        v-model="localSettings.src"
        type="text"
        class="form-input"
        placeholder="https://example.com/image.jpg"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Upload Image</label>
      <div class="form-image-upload">
        <div class="image-preview">
          <img v-if="localSettings.src" :src="localSettings.src" alt="Preview" />
          <div v-else class="image-preview-placeholder">No image selected</div>
        </div>
        <input 
          type="file"
          ref="fileInput"
          accept="image/*"
          style="display: none"
          @change="handleFileUpload"
        />
        <button class="btn btn-outline" @click="$refs.fileInput.click()" :disabled="uploading">
          {{ uploading ? 'Uploading...' : '📁 Choose File' }}
        </button>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">Alt Text</label>
      <input 
        v-model="localSettings.alt"
        type="text"
        class="form-input"
        placeholder="Image description"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Width</label>
      <input 
        v-model="localSettings.width"
        type="text"
        class="form-input"
        placeholder="100%, 300px, auto"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Link URL (optional)</label>
      <input 
        v-model="localSettings.link"
        type="url"
        class="form-input"
        placeholder="https://example.com"
        @input="emitUpdate"
      />
    </div>

    <div class="form-group">
      <label class="form-label">CSS Class</label>
      <input 
        v-model="localSettings.class"
        type="text"
        class="form-input"
        placeholder="custom-class"
        @input="emitUpdate"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useStructureApi } from '../../composables/useStructureApi';

const props = defineProps({
  settings: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localSettings = ref({ ...props.settings });
const fileInput = ref(null);
const uploading = ref(false);

const { uploadImage } = useStructureApi();

watch(() => props.settings, (newSettings) => {
  localSettings.value = { ...newSettings };
}, { deep: true });

async function handleFileUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  uploading.value = true;
  const imageUrl = await uploadImage(file);
  uploading.value = false;

  if (imageUrl) {
    localSettings.value.src = imageUrl;
    emitUpdate();
  }
}

function emitUpdate() {
  emit('update', localSettings.value);
}
</script>

